import { render, staticRenderFns } from "./NaturalResourcesRow.vue?vue&type=template&id=598aaa60&scoped=true&"
import script from "./NaturalResourcesRow.vue?vue&type=script&lang=js&"
export * from "./NaturalResourcesRow.vue?vue&type=script&lang=js&"
import style0 from "./NaturalResourcesRow.vue?vue&type=style&index=0&id=598aaa60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598aaa60",
  null
  
)

export default component.exports